import { WorkforceMetricsMode } from "PFApp/booking/types";
import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import { useMyAccountInfo } from "PFCore/hooks/queries/account/use_my_account_info";
import { FeatureFlag } from "PFTypes";

const API_TO_WORKFORCE_METRICS_MODE: Record<string, WorkforceMetricsMode> = {
  billable_utilization: WorkforceMetricsMode.BillableUtilization,
  total_utilization: WorkforceMetricsMode.TotalUtilization
};

export const useDefaultWorkforceMetricsMode = (): WorkforceMetricsMode => {
  const showUtilizationMetrics = useIsFeatureEnabled()(FeatureFlag.ShowUtilization);
  const {
    data: { config }
  } = useMyAccountInfo();

  if (!showUtilizationMetrics) {
    return WorkforceMetricsMode.TotalAvailability;
  }

  return (
    API_TO_WORKFORCE_METRICS_MODE[config.bookingModule?.defaultUtilizationMetric ?? ""] ??
    WorkforceMetricsMode.BillableUtilization
  );
};
